import { render } from "./PlatformListEmpty.vue?vue&type=template&id=41323fb9"
import script from "./PlatformListEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformListEmpty.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/PlatformListEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41323fb9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41323fb9', __exports__)) {
    api.reload('41323fb9', __exports__)
  }
  
  module.hot.accept("./PlatformListEmpty.vue?vue&type=template&id=41323fb9", () => {
    api.rerender('41323fb9', render)
  })

}


export default __exports__